import React, { Component } from "react";
import { MessageSourceProps, withMessages } from "react-message-source";
import { AuthConsumerRenderProps, withAuthContext } from 'auth/AuthContext';
import { DocumentCopiesSearchResponse } from 'ts-types/api.types';
import { PatientConsumerRenderProps, withPatientContext } from 'components/patient/PatientContext';
import DocumentCopiesSearchSegment from 'components/billing/document-copy/segments/DocumentCopiesSearchSegment';
import { Divider } from 'semantic-ui-react';
import DocumentCopiesTableSegment from 'components/billing/document-copy/segments/DocumentCopiesTableSegment';
import PraxStyledSegment from 'components/layout/PraxStyledSegment';
import styled from 'styled-components';
import { RouterProps } from 'react-router';
import FullScreenPageHeader from 'components/FullScreenPageHeader';

const StyledPraxSegment = styled(PraxStyledSegment)`
  margin-top: 0 !important;
  padding: 0 !important;
  margin-bottom: 5px !important;
`;

const ContentDiv = styled.div`
  flex: 1 1 auto;
  height: 100%;
  display: flex;
  flex-direction: column;
`;

interface Props extends AuthConsumerRenderProps, PatientConsumerRenderProps, MessageSourceProps, RouterProps {
}

interface State {
  bills: Array<DocumentCopiesSearchResponse>,
  billsLoading: boolean
}

class DocumentCopiesView extends Component<Props, State> {

  constructor(props: Props) {
    super(props);

    this.state = {
      bills: [],
      billsLoading: false
    };
  }

  onFilterBills = (bills: Array<DocumentCopiesSearchResponse>) => {
    this.setState({
      bills: bills
    })
  };

  onBillsLoadingChange = (billsLoading: boolean) => {
    this.setState({
      billsLoading: billsLoading
    })
  };

  render(): React.ReactElement {

    const {currentPatient, getMessage} = this.props;
    const {bills, billsLoading} = this.state;

    return (
        <ContentDiv>
          <FullScreenPageHeader headerMessage={getMessage("header.navigation.documentCopies")}
                                buttonMessage={getMessage("back")}
                                onConfirm={() => this.goToHome()}/>

          <StyledPraxSegment>
            <DocumentCopiesSearchSegment
                currentPatient={currentPatient}
                onFilterBills={this.onFilterBills}
                onBillsLoadingChange={this.onBillsLoadingChange}
            />
            <Divider/>
            <DocumentCopiesTableSegment
                currentPatient={currentPatient}
                bills={bills}
                billsLoading={billsLoading}
                onFilterBills={this.onFilterBills}
                onBillsLoadingChange={this.onBillsLoadingChange}
            />
          </StyledPraxSegment>
        </ContentDiv>
    );
  };

  goToHome = () => {
    const {history} = this.props;

    history.push("/");
  };

}

export default withAuthContext(withPatientContext(withMessages(DocumentCopiesView)));
